module.exports = __webpack_public_path__ + "static/img/img-about-7-1.846ad9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-7-1.png
// module id = K6QW
// module chunks = 0